<template>
  <div class="logonLeft">
    <img :src="img">
  </div>
</template>
<script>
import no_photo from '@/assets/images/html/logon02.jpg'
export default {
  name: "LoginLogo",
  componentName: "LoginLogo",
  data () {
    return {
      img: no_photo,
      get_carousel_banner: 'webpart/self_nleft_part/',
    }
  },
  created () {
    //获取签证轮播图广告
    this.$myGet(this.get_carousel_banner + 'login_img')
      .then(res => {
        if (res.response.data.img_urls && res.response.data.img_urls.length > 0) {
          this.img = res.response.data.img_urls[0]
        }
      })
      .catch(err => {
        this.$msg('[' + err.status + ']' + err.message, 'error')
      })
  }
}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/pages/components/loginLogo.vue